export default {
	APPROVED: 'Approved',
	IN_MEDIATION: 'In Mediation',
	INELIGIBLE: 'Ineligible',
	PAID: 'Paid',
	PENDING_REVIEW: 'Pending Review',
}
